// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1uWgf","buttons":"RemoveExpirationActionButtons_buttons__3g9Ce"};